// @flow

export class RecaptchaLoadError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'RecaptchaLoadError';
  }
}
